import React from "react";
import {
  t,
  KS_CLICK_HERE,
  KS_HEADING1,
  KS_HEADING2,
  KS_HEADING3,
  DEPOTS,
  DIVISIONS,
  BUS_STATIONS,
  VEHICLES,
  SCHEDULES,
  EFFECTIVE_KM_PER_DAY,
  ITALY,
  AVG_TRA_REV_PER_DAY,
  LAKH,
  AVG_PASS_TRA_PER_DAY,
  STAFF,
  STAFF_RATION_PER_SCHE,
} from "../../translations/AboutUs/KeyStatistics";

function KeyStatistics() {
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div
        className="a-large"
        style={{ fontWeight: 400, textAlign: "left" }}>
        {t(KS_HEADING1)}{" "}
        <a
          href="http://www.ksrtc.in"
          style={{ textDecoration: "underline", color: "blue" }}
          target="_blank"
        >
          {t(KS_CLICK_HERE)}
        </a>
        &nbsp;{t(KS_HEADING2)}
      </div>
      <div
        className="a-large"
        style={{ fontWeight: 400, textAlign: "left" }}>
        {t(KS_HEADING3)}
      </div>
      <table>
        <tbody>
          <tr>
            <td style={{ backgroundColor: "#E5F3FF" }}>1</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>{t(DEPOTS)}</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>83</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#F3F9FF" }}>2</td>
            <td style={{ backgroundColor: "#F3F9FF" }}>{t(DIVISIONS)}</td>
            <td style={{ backgroundColor: "#F3F9FF" }}>17</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#E5F3FF" }}>3</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>{t(BUS_STATIONS)}</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>164</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#F3F9FF" }}>4</td>
            <td style={{ backgroundColor: "#F3F9FF" }}>{t(VEHICLES)}</td>
            <td style={{ backgroundColor: "#F3F9FF" }}>8406</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#E5F3FF" }}>5</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>{t(SCHEDULES)}</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>6347</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#F3F9FF" }}>6</td>
            <td style={{ backgroundColor: "#F3F9FF" }}>
              {t(EFFECTIVE_KM_PER_DAY)}
            </td>
            <td style={{ backgroundColor: "#F3F9FF" }}>{t(ITALY)}</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#E5F3FF" }}>7</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>
              {t(AVG_TRA_REV_PER_DAY)}
            </td>
            <td style={{ backgroundColor: "#E5F3FF" }}>Rs.618.11 {t(LAKH)}</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#F3F9FF" }}>8</td>
            <td style={{ backgroundColor: "#F3F9FF" }}>
              {t(AVG_PASS_TRA_PER_DAY)}
            </td>
            <td style={{ backgroundColor: "#F3F9FF" }}>12.93 {t(LAKH)}</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#E5F3FF" }}>9</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>{t(STAFF)}</td>
            <td style={{ backgroundColor: "#E5F3FF" }}>37618</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: "#F3F9FF" }}>10</td>
            <td style={{ backgroundColor: "#F3F9FF" }}>
              {t(STAFF_RATION_PER_SCHE)}
            </td>
            <td style={{ backgroundColor: "#F3F9FF" }}>5.93</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default KeyStatistics;
